// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/UnileverShilling.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/UnileverShillingMedium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/UnileverShillingBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/UnileverShillingItalic.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col-custom-width {
  max-width: 14.28%;
}

@font-face {
  font-family: 'Unilever Shilling';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Unilever Shilling';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Unilever Shilling';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: 'Unilever Shilling';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: 400;
  font-style: italic;
}

body {
  font-family: 'Unilever Shilling', sans-serif;
  background-color: #eaeaea;
  font-size: 0.875rem;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-bottom: 0.5rem;
  font-family: inherit;
  line-height: 1.2;
  color: inherit;
  font-weight: 900;
}

h1,
.h1 {
  font-size: 2.25rem;
}

h2,
.h2 {
  font-size: 1.875rem;
}

h3,
.h3 {
  font-size: 1.5rem;
}

h4,
.h4 {
  font-size: 1.125rem;
}

h5,
.h5 {
  font-size: 0.813rem;
}

h6,
.h6 {
  font-size: 1rem;
}

.show-empty-badge {
  display: inline-block !important;
  height: 0.938rem;
  width: 2.188rem;
}

.feather {
  width: 1rem;
  height: 1rem;
  vertical-align: text-bottom;
}


/*
   * Navbar
   */





.navbar .form-control {
  padding: .75rem 1rem;
  border-width: 0;
  border-radius: 0;
}

.form-control-dark {
  color: #fff;
  background-color: rgba(255, 255, 255, .1);
  border-color: rgba(255, 255, 255, .1);
}

.form-control-dark:focus {
  border-color: transparent;
  box-shadow: 0 0 0 0.188rem rgba(255, 255, 255, .25);
}

.box-p-min-height {
  min-height: 4.063rem;
}

.card-body {
  padding: 0.625rem !important;
}

.library-details {
  padding: 20px !important;
}
.accordion-button {
  background-color: #C7C7C7
}

.accordion-button:focus {
  box-shadow: none;
}

.accordion-button:not(.collapsed) {
  color: #212529;
}


.prompt-playground .small-box {
  background-color: #9C44C0;
  color: #FFFFFF;
  min-height: 175px;
}
.prompt-playground .error-box {
  background-color: #EC6157;
  color: #FFFFFF;
  min-height: 175px;
}

.prompt-playground-card-heading {
  font-size: 18px;
  font-style: normal;
  font-weight: 900;
  line-height: 120%;
  /* 21.6px */
}

.prompt-playground .card-header {
  padding-left: 10px !important;
}

@media (max-width: 1200px) {
  h1 {
    font-size: 36px;
  }
}

@media (max-width: 992px) {
  h1 {
    font-size: 34px;
  }
}

@media (max-width: 768px) {
  h1 {
    font-size: 32px;
  }
}

@media (max-width: 576px) {
  h1 {
    font-size: 30px;
  }
}



.uni-bg-blue {
  background-color: #2435BF;
}

.uni-header {
  display: flex;
  min-height: 130px;
  padding: 3px 12px 3px 12px;
  align-items: center;
  gap: 197px;

}


.uni-brand-text {
  display: flex;
  width: 210px;
  height: 73px;
  flex-direction: column;
  justify-content: center;
}

.uni-header-primary {
  color: #FFFFFF;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  /* 33.6px */
}

.uni-header-secondary {
  color: #FFFFFF;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

.user-img {
  height: 50px;
  width: 50px;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,2DAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2DAAmE;EACnE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2DAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;EAYE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;;AAGA;;IAEI;;;;;;AAMJ;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;;;AAIA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,UAAU;;AAEZ;;;AAGA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":["@import 'bootstrap/dist/css/bootstrap.min.css';\n\n.col-custom-width {\n  max-width: 14.28%;\n}\n\n@font-face {\n  font-family: 'Unilever Shilling';\n  src: url('./assets/fonts/UnileverShilling.woff') format('woff');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Unilever Shilling';\n  src: url('./assets/fonts/UnileverShillingMedium.woff') format('woff');\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Unilever Shilling';\n  src: url('./assets/fonts/UnileverShillingBold.woff') format('woff');\n  font-weight: 900;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Unilever Shilling';\n  src: url('./assets/fonts/UnileverShillingItalic.woff2') format('woff');\n  font-weight: 400;\n  font-style: italic;\n}\n\nbody {\n  font-family: 'Unilever Shilling', sans-serif;\n  background-color: #eaeaea;\n  font-size: 0.875rem;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  margin-bottom: 0.5rem;\n  font-family: inherit;\n  line-height: 1.2;\n  color: inherit;\n  font-weight: 900;\n}\n\nh1,\n.h1 {\n  font-size: 2.25rem;\n}\n\nh2,\n.h2 {\n  font-size: 1.875rem;\n}\n\nh3,\n.h3 {\n  font-size: 1.5rem;\n}\n\nh4,\n.h4 {\n  font-size: 1.125rem;\n}\n\nh5,\n.h5 {\n  font-size: 0.813rem;\n}\n\nh6,\n.h6 {\n  font-size: 1rem;\n}\n\n.show-empty-badge {\n  display: inline-block !important;\n  height: 0.938rem;\n  width: 2.188rem;\n}\n\n.feather {\n  width: 1rem;\n  height: 1rem;\n  vertical-align: text-bottom;\n}\n\n\n/*\n   * Navbar\n   */\n\n\n\n\n\n.navbar .form-control {\n  padding: .75rem 1rem;\n  border-width: 0;\n  border-radius: 0;\n}\n\n.form-control-dark {\n  color: #fff;\n  background-color: rgba(255, 255, 255, .1);\n  border-color: rgba(255, 255, 255, .1);\n}\n\n.form-control-dark:focus {\n  border-color: transparent;\n  box-shadow: 0 0 0 0.188rem rgba(255, 255, 255, .25);\n}\n\n.box-p-min-height {\n  min-height: 4.063rem;\n}\n\n.card-body {\n  padding: 0.625rem !important;\n}\n\n.library-details {\n  padding: 20px !important;\n}\n.accordion-button {\n  background-color: #C7C7C7\n}\n\n.accordion-button:focus {\n  box-shadow: none;\n}\n\n.accordion-button:not(.collapsed) {\n  color: #212529;\n}\n\n\n.prompt-playground .small-box {\n  background-color: #9C44C0;\n  color: #FFFFFF;\n  min-height: 175px;\n}\n.prompt-playground .error-box {\n  background-color: #EC6157;\n  color: #FFFFFF;\n  min-height: 175px;\n}\n\n.prompt-playground-card-heading {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 900;\n  line-height: 120%;\n  /* 21.6px */\n}\n\n.prompt-playground .card-header {\n  padding-left: 10px !important;\n}\n\n@media (max-width: 1200px) {\n  h1 {\n    font-size: 36px;\n  }\n}\n\n@media (max-width: 992px) {\n  h1 {\n    font-size: 34px;\n  }\n}\n\n@media (max-width: 768px) {\n  h1 {\n    font-size: 32px;\n  }\n}\n\n@media (max-width: 576px) {\n  h1 {\n    font-size: 30px;\n  }\n}\n\n\n\n.uni-bg-blue {\n  background-color: #2435BF;\n}\n\n.uni-header {\n  display: flex;\n  min-height: 130px;\n  padding: 3px 12px 3px 12px;\n  align-items: center;\n  gap: 197px;\n\n}\n\n\n.uni-brand-text {\n  display: flex;\n  width: 210px;\n  height: 73px;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.uni-header-primary {\n  color: #FFFFFF;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 140%;\n  /* 33.6px */\n}\n\n.uni-header-secondary {\n  color: #FFFFFF;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n}\n\n.user-img {\n  height: 50px;\n  width: 50px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
